<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>Plano de Contas</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Plano de Contas</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO CODIGO -->
                  <v-flex xs12 sm1>
                    <v-text-field
                      v-model="plano.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8>
                    <v-text-field v-model="plano.descricao" label="Descrição" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      label="Controla odômetro"
                      v-model="plano.controla_odometro"
                      false-value="N"
                      true-value="S"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-select v-model="plano.tipo" :items="items" label="Tipo" required></v-select>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-select v-model="plano.receita_despesa" :items="items1" label="Receita/Despesa" required></v-select>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-currency-field
                      v-model="plano.valor"
                      label="Valor"
                      v-bind="currency_litro"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field v-model="plano.codigo_integracao" label="Código integração" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/plano')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="salvar()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError } from '@/utils'
import planoService from '@/services/plano'

export default {
  name: 'plano',
  data () {
    return {
      item: {
        lanctto: ''
      },
      itemlancto: {
        descr: ''
      },
      tipo: {
        descr: ''
      },
      currency_litro: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 4,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      items: ['Abastecimento', 'Despesa', 'Serviço', 'Receita'],
      items1: ['R', 'D'],
      resultado: {},
      plano: {},
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: ''
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.plano = {}
      if (id === undefined) {
        this.modo = 'I'
        this.loading = false
        return
      }
      this.modo = 'A'
      this.plano = await planoService.getById(id)
      this.loading = false
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async salvar () {
      try {
        if (this.modo === 'A') {
          this.resultado = await planoService.savePut(this.plano)
          this.$router.push(`/plano`)
        } else {
          this.resultado = await planoService.savePost(this.plano)
          this.plano.descricao = ''
        }
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
.e-data-table3 {
  background: red;
}
</style>
